import React, { useState, useEffect, useRef } from "react";
import {
  API_BASE_URL,
  GET_ORDERS_BY_ID
} from "../../../Config";
import Axios from "axios";
// import Swal from "sweetalert2";
import PropTypes from "prop-types";
// import UploadFiles from "../../../feature-module/UploadFiles";
// import jsPDF from 'jspdf';
// import html2pdf from 'html2pdf.js';
import PrintContent from './print';

const DeliveryItemView = ({ deliveryViewObj }) => {
    const [userDataSession, setUserDataSession] = useState([]);
    const [viewLoading, setViewDataLoading] = useState(false);
    const [viewData, setViewData] = useState([]);
    // const printRef = useRef(); 

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserDataSession(userData);
        } else {
        console.log("User data not found in sessionStorage");
        }
    }, []);

    useEffect(() => {
        setViewDataLoading(true);
        Axios.get(`${API_BASE_URL}${GET_ORDERS_BY_ID}?OrgId=${userDataSession.OrgId}&OrderId=${deliveryViewObj.Id}`)
            .then((response) => {
            if (response.data.Status) {
                setViewData(response.data.ResultData);
                setViewDataLoading(false);
                console.log(deliveryViewObj);
            } else {
                setViewDataLoading(false);
                console.error("Error fetching data:", response.data.Message);
            }
            })
            .catch((error) => {
                setViewDataLoading(false);
                console.error("Error fetching data:", error);
            });
    }, [deliveryViewObj]);

    // const handlePrint = () => {
    //     const element = document.getElementById("pdf-content"); // Select the content to print
    //     const options = {
    //         margin: 1,
    //         filename: `Order_${deliveryViewObj.OrderNo}.pdf`,
    //         image: { type: "jpeg", quality: 0.98 },
    //         html2canvas: { scale: 2 },
    //         jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
    //     };
    //     html2pdf().set(options).from(element).save();
    // };

    const printRef = useRef();

    const handlePrint = () => {
        if (printRef.current) {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(`
                <html>
                    <head>
                        <title>Print</title>
                    </head>
                    <body>
                        <div>${printRef.current.innerHTML}</div>
                    </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          } else {
            console.error('printRef.current is undefined');
          }
    };

    return (
        <div>
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightViewDeliChal"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: "45%" }}
            >
                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <h4 id="offcanvasRightLabel" className="mb-0">
                        View Order <span className="text-primary fw-semibold">({deliveryViewObj?.OrderNo})</span>
                    </h4>
                    
                    <div>
                        <button onClick={handlePrint} className="btn btn-link me-2">
                            <i className="fa-solid fa-print fs-5"></i>
                        </button>
                        <button
                            type="button"
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        />
                    </div>
                </div>
                <hr />
                <div className="offcanvas-body">
                    {viewLoading ? <div className="loader m-auto"></div> : 
                        <div id="pdf-content">
                            <div className="row">
                                <div className="col-6">
                                    <label className="form-label">Customer</label>
                                    <input 
                                        className="form-control"
                                        value={deliveryViewObj?.CustomerName} 
                                        readOnly
                                    />
                                </div>
                                <div className="col-6">
                                    <label className="form-label">Date</label>
                                    <input 
                                        className="form-control"
                                        value={deliveryViewObj?.Orderdate ? new Date(deliveryViewObj.Orderdate).toLocaleDateString('en-GB') : ''} 
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Item</th>
                                            <th>Quantity</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {viewData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.ProductName}</td>
                                                <td>{item.Quantity}</td>
                                                <td>{item.UnitPrice}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan={6}>
                                                Total RS.{deliveryViewObj?.Total}/-
                                            </th>
                                        </tr>    
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className='d-none'>
                {viewData ? (
                    <PrintContent ref={printRef} data={viewData} deliveryObj={deliveryViewObj} />
                ) : (
                    <p>Loading...</p>
                )}
            </div>
        </div>
    );
};

DeliveryItemView.propTypes = {
    deliveryViewObj: PropTypes.object.isRequired,
};
export default DeliveryItemView;